import { takeEvery } from 'redux-saga/effects';

var takes = function takes(_ref) {
  var types = _ref.types,
    sagas = _ref.sagas;
  return [takeEvery(types.GET_SOCIAL_LINKS, sagas.getSocialLinks), takeEvery(types.CREATE_LINK, sagas.createLink), takeEvery(types.UPDATE_LINK, sagas.updateLink), takeEvery(types.DELETE_LINK, sagas.deleteLink)];
};

export { takes as default };
//# sourceMappingURL=takes.js.map
